var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class:
        "p-05 col-12 col-sm-6 col-md-4" +
        (_vm.service_settings.max_column_count === 4 ? " col-lg-3" : ""),
    },
    [
      _c("div", { staticClass: "card pb-5" }, [
        _vm.resource.cover !== null
          ? _c("div", { staticClass: " shadow" }, [
              _c(
                "a",
                {
                  attrs: {
                    href: "/" + _vm.resource.type + "/" + _vm.resource.slug,
                  },
                },
                [
                  _c("img", {
                    staticClass: "img-fluid card-img-top ",
                    staticStyle: { "object-fit": "cover" },
                    attrs: { src: _vm.resource.cover.url },
                  }),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "card-content pl-05 pt-1 pr-1 pb-0" }, [
          _c(
            "div",
            { staticClass: "d-flex flex-row justify-content-between" },
            [
              _c("div", { staticClass: "flex-fill" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "/" + _vm.resource.type + "/" + _vm.resource.slug,
                    },
                  },
                  [
                    _vm.resource.cover === null
                      ? _c("div", [
                          _vm.resource.resource_file_type === "doc"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "d-inline-block mr-05 mb-05 float-left",
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: "/images/icons/doc.png",
                                      width: "25",
                                      alt: "Document",
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.resource.resource_file_type === "docx"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "d-inline-block mr-05 mb-05 float-left",
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: "/images/icons/doc.png",
                                      width: "25",
                                      alt: "Document",
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.resource.resource_file_type === "txt"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "d-inline-block mr-05 mb-05 float-left",
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: "/images/icons/doc.png",
                                      width: "25",
                                      alt: "Text file",
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.resource.resource_file_type === "pdf"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "d-inline-block mr-05 mb-05 float-left",
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: "/images/icons/pdf.png",
                                      width: "25",
                                      alt: "PDF document",
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.resource.resource_file_type === "xls"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "d-inline-block mr-05 mb-05 float-left",
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: "/images/icons/xls.png",
                                      width: "25",
                                      alt: "Spreadsheet",
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.resource.resource_file_type === "xlsx"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "d-inline-block mr-05 mb-05 float-left",
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: "/images/icons/xls.png",
                                      width: "25",
                                      alt: "Spreadsheet",
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.resource.resource_file_type === "ppt"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "d-inline-block mr-05 mb-05 float-left",
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: "/images/icons/ppt.png",
                                      width: "25",
                                      alt: "Powerpoint presentation",
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.resource.resource_file_type === "pptx"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "d-inline-block mr-05 mb-05 float-left",
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: "/images/icons/ppt.png",
                                      width: "25",
                                      alt: "Powerpoint presentation",
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "h5 text-bold-700 pl-05" }, [
                      _vm._v(_vm._s(_vm.resource.title.substring(0, 70))),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _vm.resource.disabled === 1
                  ? _c("div", [
                      _c(
                        "span",
                        {
                          staticClass:
                            "badge badge-pill bg-danger mb-05 text-bold-700 font-small-2",
                        },
                        [
                          _c("i", { staticClass: "feather icon-alert-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.__(
                                  _vm.resource.type.replace("-", "_") + ".title"
                                )
                              ) +
                              " Inactive\n                        "
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-center w-100 ",
                  },
                  [
                    this.rating !== null && this.rating !== 0
                      ? _c("div", { staticClass: "mt-05  mb-05" }, [
                          _c("span", {
                            class: "rating-static rating-" + this.rating * 10,
                          }),
                        ])
                      : _vm._e(),
                  ]
                ),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _vm.service_settings.description_display
          ? _c("div", {
              staticClass:
                "card-content resource-description font-small-4 mt-1 px-1",
              domProps: { innerHTML: _vm._s(_vm.description) },
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "card-bottom m-05 p-0 d-flex align-items-center justify-content-between",
            staticStyle: { width: "96%" },
          },
          [
            _c(
              "button",
              {
                staticClass: "btn-sm btn-flat-light ml-auto",
                staticStyle: { border: "none" },
              },
              [
                _c("a", { attrs: { href: "/resource/" + _vm.resource.slug } }, [
                  _vm._v(_vm._s(_vm.__("globals.view")) + " "),
                  _c("i", { staticClass: "feather icon-chevron-right" }),
                ]),
              ]
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }